import type { Directive } from "vue";

// Focuses the element on mount. Prefer this over native `autofocus`, which
// browsers honor only once per document — Inertia keeps the document across
// visits, so autofocus silently stops working after the first page.
// `v-focus="false"` skips it, for components that only sometimes own focus.
export const vFocus: Directive<HTMLElement, boolean | undefined> = {
    mounted: (el, { value }) => {
        if (value !== false) {
            el.focus();
        }
    },
};
